// extracted by mini-css-extract-plugin
module.exports = {"header":"view_header__3X-XB","closeBtn":"view_closeBtn__3bwQl","ownerCont":"view_ownerCont__2D_FL","title":"view_title__1sQLk"};